declare let mxStyleChange: any; // available globally
declare let mxValueChange: any; // available globally
import * as _ from 'lodash';

export function interactionGraphChange(graph, cell, change) {
  if (change instanceof mxStyleChange || change instanceof mxValueChange) {
    return null;
  }

  const geometry = cell.geometry;

  const action = {
    flowlineMxKey: +cell.parent.id,
    offset: {
      x: geometry.offset.x,
      y: geometry.offset.y
    }
  };

  return {
    data: _.cloneDeep(action),
    action: 'changeInteraction',
    type: 'interaction',
    mxKey: cell.id // this is string in interaction cells (parent.id + 'ian')
  };
}
